"use client";

/**
 * Full-page placeholder shown while dashboard data loads after sign-in.
 * Matches PeeqdToolDashboardZone layout so the transition feels instant.
 */
export default function DashboardBootstrapShell() {
  return (
    <section className="min-h-screen border-b border-line bg-bg" aria-busy="true" aria-label="Loading your dashboard">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col lg:flex-row lg:items-start">
        <div className="flex w-full shrink-0 flex-col border-b border-line px-4 py-6 sm:px-6 lg:w-[min(320px,32%)] lg:border-b-0 lg:border-r lg:px-6 lg:py-8">
          <p className="text-[12px] font-semibold uppercase tracking-widest text-rose-deep">Your dashboard</p>
          <div className="mt-4 space-y-2">
            <div className="sk h-16 rounded-2xl" />
            <div className="sk h-16 rounded-2xl" />
          </div>
        </div>

        <div className="flex w-full min-w-0 flex-1 flex-col gap-4 py-5 pl-4 pr-4 sm:py-6 sm:pl-5 sm:pr-6 lg:py-7 lg:pl-6 lg:pr-8">
          <div className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card">
            <div className="flex gap-4 border-b border-line p-4 sm:gap-5 sm:p-5">
              <div className="sk h-[72px] w-[72px] shrink-0 rounded-full sm:h-20 sm:w-20" />
              <div className="min-w-0 flex-1 space-y-2.5 pt-1">
                <div className="sk h-5 w-40" />
                <div className="sk h-3.5 w-28" />
                <div className="sk h-4 w-56" />
              </div>
            </div>
          </div>

          <div className="sk h-10 w-full max-w-md rounded-xl" />
          <div className="sk h-28 w-full rounded-2xl" />
          <div className="sk h-12 w-full max-w-lg rounded-2xl" />

          <div className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card">
            <div className="sk h-12" />
            <div className="space-y-2 p-4">
              <div className="sk h-32 rounded-xl" />
              <div className="sk h-32 rounded-xl" />
            </div>
          </div>

          <p className="text-center text-[13px] font-medium text-muted">Loading your dashboard…</p>
        </div>
      </div>
    </section>
  );
}
